import {Field, FormValue, RadioboxGroup, SimpleRadiobox, TextInput} from '@startlibs/form';
import {SplitColumnsContainer} from '@startlibs/components'
import React from 'react'
import {FormBox, RemoveFormBox} from '../../components/FormBox';
import {useRemoveQuestion} from './useRemoveQuestion'
import {MEDICARE, OTHER, PRIVATE} from '../../enums/InsuranceType'
import _ from 'lodash/fp'
import styled from 'styled-components';
import {removeExtraInsuranceFields} from './utils'
import { useIntl } from 'react-intl';

const InsuranceEditBox = styled(FormBox)`
  ${SimpleRadiobox} {
    overflow: hidden;
    border-radius: 6px;
    background: white;
  }
`

export const INSURANCE_ORDER_TITLE = {
  0: "Primary insurance",
  1: "Secondary insurance",
  2: "Tertiary insurance",
}

const constraint = /[^\d\w\s]/

const useInsuranceOrderLabels = () => {
  const intl = useIntl();

  return {
    0: intl.formatMessage({
      defaultMessage: "Primary insurance type",
      description: "Insurance order title for primary",
    }),
    1: intl.formatMessage({
      defaultMessage: "Secondary insurance type",
      description: "Insurance order title for secondary",
    }),
    2: intl.formatMessage({
      defaultMessage: "Tertiary insurance type",
      description: "Insurance order title for tertiary",
    }),
  };
};

export const Insurance = ({form, path, i, disabled, canRemove}) => {
  const removeQuestion = useRemoveQuestion(form, path, i,({id,...rest}) => Object.values(removeExtraInsuranceFields(rest)).filter(_.identity).length>1)

  const indexedPath = [...path,i]
  const intl = useIntl()
  const insuranceLabels = useInsuranceOrderLabels();

  return <InsuranceEditBox>
    {!disabled && canRemove && <RemoveFormBox onClick={removeQuestion}/>}
    <RadioboxGroup
      disabled={disabled}
      mandatory
      // label={`${INSURANCE_ORDER_TITLE[i]} type`}
      label={insuranceLabels[i]}
      horizontal
      path={[...indexedPath, "type"]}
      framedBoxes
      wide
      highlightSelected={!disabled}
    >
      <SimpleRadiobox fieldValue={MEDICARE} label={intl.formatMessage({defaultMessage:"Medicare", description:"Insurance type: Medicare"})}/>
      <SimpleRadiobox fieldValue={PRIVATE} label={intl.formatMessage({defaultMessage:"Private insurance", description:"Insurance type: Private insurance"})}/>
      <SimpleRadiobox fieldValue={OTHER} label={intl.formatMessage({defaultMessage:"Other", description:"Insurance type: Other"})}/>
    </RadioboxGroup>
    <FormValue path={["patientInfo", "insurances", i, "type"]}>{(insuranceType) =>
      <>
        {
          insuranceType === MEDICARE &&
          <MedicareFields
            canRemove
            disabled={disabled}
            withTitle
            form={form}
            path={path}
            i={i}
          />
        }
        {
          insuranceType === PRIVATE &&
          <PrivateFields
            i={i}
            path={path}
            disabled={disabled}
            intl={intl}
          />
        }
        {
          insuranceType === OTHER &&
          <Field 
            // label="Please insert the insurance information below"
            label={intl.formatMessage({defaultMessage:"Please insert the insurance information below", description:"Please insert the insurance information below"})}
          >
            <TextInput
              path={["patientInfo", "insurances", i, "info"]}
              textarea
              // placeholder="Type other insurance information here"
              placeholder={intl.formatMessage({defaultMessage:"Type other insurance information here", description:"Placeholder for other insurance information"})}
              disabled={disabled}
              className='fs-exclude'
            />
          </Field>
        }
      </>
    }</FormValue>

  </InsuranceEditBox>
}


const PrivateFields = ({disabled, path,i, intl}) => <>
  <SplitColumnsContainer>
    <TextInput
      disabled={disabled}
      // label="Insurance carrier"
      // placeholder="Ex: UnitedHealth"
      label={intl.formatMessage({defaultMessage:"Insurance carrier", description:"Insurance carrier"})}
      placeholder={intl.formatMessage({defaultMessage:"Ex: UnitedHealth", description:"Insurance carrier placeholder"})}
      path={[...path,i,'insuranceCarrier']}
      mandatory
    />
    <TextInput
      disabled={disabled}
      // label="Member #"
      // placeholder="Ex: X X X X - X X X - X X X X"
      label={intl.formatMessage({defaultMessage:"Member #", description:"Member #"})}
      placeholder={intl.formatMessage({defaultMessage:"Ex: X X X X - X X X - X X X X", description:"Member # placeholder"})}
      constraint={constraint}
      path={[...path,i,'memberNumber']}
      mandatory
    />
    <TextInput
      disabled={disabled}
      // label="Group #"
      // placeholder="Ex: X X X X - X X X - X X X X"
      label={intl.formatMessage({defaultMessage:"Group #", description:"Group #"})}
      placeholder={intl.formatMessage({defaultMessage:"Ex: X X X X - X X X - X X X X", description:"Group # placeholder"})}
      constraint={constraint}
      path={[...path,i,'groupNumber']}
      mandatory
    />
  </SplitColumnsContainer>
  <SplitColumnsContainer>
    <TextInput
      disabled={disabled}
      // label="Name of insured"
      // placeholder="Ex: John Doe"
      label={intl.formatMessage({defaultMessage:"Name of insured", description:"Name of insured"})}
      placeholder={intl.formatMessage({defaultMessage:"Ex: John Doe", description:"Name of insured placeholder"})}
      path={[...path,i,'insurancedName']}
      helpText="(if not the patient)"
    />
  </SplitColumnsContainer>
</>

const formatMedicode = (v) => v.replace(/[\W-]/g, '').replace(/(\w{0,4})(\w{0,3})(\w{0,4}).*/, "$1-$2-$3").replace(/-*$/, "")

const MedicareFields = ({disabled,path,i}) => <>
  <TextInput
    disabled={disabled}
    label="Medicare code"
    path={[...path,i,"code"]}
    constraint={formatMedicode}
    mandatory
    helpText="(X X X X - X X X - X X X X)"
    placeholder="Ex: X X X X - X X X - X X X X"
  />
</>
